import * as analytics from "expo-firebase-analytics";
import Mixpanel from "./Mixpanel";
import { Platform } from "react-native";
import config from "./Config";
import Sentry from "./Sentry";

let MixpanelBrowser: any;
if (Platform.OS === "web") {
  MixpanelBrowser = require("mixpanel-browser");
}

export class AnalyticsService {
  constructor() {
    this.mixpanel_instance = null;
    this.configureMixpanel();
  }

  mixpanel_instance: any;

  async configureMixpanel() {
    if (Platform.OS === "android") {
      // this.mixpanel_instance = await Mixpanel.init(config.mixpanel);
      this.mixpanel_instance = Mixpanel;
    } else {
      this.mixpanel_instance = MixpanelBrowser;
      this.mixpanel_instance.init(config.mixpanel);
    }
  }

  mixpanelSetUser(id: string, data: any) {
    try {
      this.mixpanel_instance.identify(id);

      if (Platform.OS === "android") {
        this.mixpanel_instance.people_set(data);
      }

      if (Platform.OS === "web") {
        Object.keys(data).forEach((value, key) => {
          this.mixpanel_instance.people.set(`${key}`, value);
        });
      }
    } catch (e) {
      this.logError(e);
    }
  }

  async logEvent(event: string, user: any, entity: any = null) {
    try {
      let _user = Object.assign({}, user);
      // ["_id", "phone", "name", "person", "address", "status", "user_id", "location_id", "store_type_id", "created", "modified", "store_type", "location", "order_count", "order_group_count", "ledgers", "orders", "order_ratings", "average_rating", "order_breakdown", "tickets", "schedule", "devices", "sessions"]
      const { _id, user_id, location_id } = _user;
      let _parameter: any = Object.assign({}, { _id, user_id, location_id });
      if (entity) {
        Object.keys(entity).forEach((key) => {
          _user[key] = entity[key];
          _parameter[key] = entity[key];
        });
      }
      if (Platform.OS == "web" && this.mixpanel_instance) {
        this.mixpanel_instance.track(event, _user);
      }

      if (Platform.OS == "android" && this.mixpanel_instance) {
        this.mixpanel_instance.track(`NATIVE - ${event}`, _user);
      }

      const googleEvent = event
        .replace(/[^A-Za-z0-9]/g, "_")
        .split(" ")
        .join("_")
        .toLowerCase();
      this.googleHelpers.logEvent(`${googleEvent}`, _parameter);
    } catch (e) {
      this.logError(e);
    }
  }

  googleHelpers = new analytics.FirebaseAnalyticsJS(
    {
      appId: "1:789499407330:android:623627b943e5ac6cb0a7bb",
      apiKey: "GV9Jm2u7rmsCe65wKzPTw5jtS38n2tVEGiS0lxQ",
      measurementId: "G-W3WBWJGW5J",
    },
    {
      clientId: "222421849",
    }
  );

  logError(exception: ErrorEvent) {
    if (Platform.OS === "android") {
      Sentry.Native.captureException(exception);
    } else {
      Sentry.Browser.captureException(exception);
    }
  }
  logErrorMessage(message: string) {
    if (Platform.OS === "android") {
      Sentry.Native.captureMessage(message);
    } else {
      Sentry.Browser.captureMessage(message);
    }
  }
}
